export const lakehousePlatform = {
  id: 8,
  title: "Lakehouse Platform",
  activityId: [6, 7], // Multi-activity project: started in activity 6, continued in activity 7
  startDate: '2024-03-01',
  endDate: null,
  description: "Modernized the Mercedes-Benz Van Operations Data Platform by migrating from a legacy Data Warehouse to a scalable Data Lakehouse architecture using Databricks.",
  categorizedSkills: {
    profession: [
      { name: "Data Engineering", weight: 1 },
      { name: "Infrastructure Management", weight: 0.8 },
      { name: "Data Architecture", weight: 1 },
      { name: "Performance Optimization", weight: 0.7 }
    ],
    lead: [
      { name: "Project Management", weight: 0.9 },
      { name: "Technical Mentoring", weight: 0.9 },
      { name: "Engineering Leadership", weight: 0.8 },
      { name: "Cross-functional Collaboration", weight: 0.9 }
    ],
    tools: [
      { name: "Databricks", weight: 1 },
      { name: "Delta Lake", weight: 1 },
      { name: "Unity Catalog", weight: 1 },
      { name: "Apache Spark", weight: 0.9 },
      { name: "dbt", weight: 0.9 },
      { name: "pytest", weight: 0.8 },
      { name: "Typer CLI", weight: 0.8 },
      { name: "Databricks Asset Bundles", weight: 0.8 },
      { name: "Azure", weight: 0.8 },
      { name: "SQL Server", weight: 0.7 },
      { name: "Git", weight: 0.9 },
      { name: "Jupyter Notebooks", weight: 0.8 },
      { name: "Terraform", weight: 0.8 }
    ],
    language: [
      { name: "SQL", weight: 0.8 },
      { name: "Python", weight: 0.8 },
      { name: "YAML", weight: 0.7 }
    ]
  },
  goal: "Modernize the Mercedes-Benz Van Operations Data Platform by migrating from a legacy Data Warehouse to a scalable Data Lakehouse architecture using Databricks.",
  detailsFile: "lakehouse-platform.md", // Reference to markdown file
  metrics: [
    "1.4 TB of data successfully migrated from the legacy warehouse",
    "150+ Delta tables orchestrated and deployed",
    "6 colleagues onboarded to the platform",
    "+90% faster data sharing achieved via Unity Catalog"
  ],
  role: "Lead Data Engineer & Platform Architect",
  teamSize: "15+",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: true
};
